<template>
    <div>
      <div class="crumbs">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>警报点管理</el-breadcrumb-item>
          <el-breadcrumb-item>警报点详细信息</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-menu :default-active="activeRouter" class="el-menu-vertical-demo" mode="horizontal" @select="handleSelect" router>
        <el-menu-item index="/alarmPointView">警报点节点信息</el-menu-item>
        <el-menu-item index="/alarmControllerView">警报点控制器信息</el-menu-item>
        <el-menu-item index="/alarmView">警报器信息</el-menu-item>
        <el-menu-item index="/iotterminal">物联网监测终端信息</el-menu-item>
        <el-submenu >
          <template slot="title">动态数据</template>
          <el-menu-item index="/realTimeData">实时数据</el-menu-item>
          <el-menu-item index="/historyData">历史数据</el-menu-item>
        </el-submenu>
        <el-submenu index="3">
          <template slot="title">历史记录查询</template>
          <el-menu-item index="3-1">静态信息修改记录</el-menu-item>
          <el-menu-item index="/alarmInspectRecord">巡检记录</el-menu-item>
          <el-menu-item index="3-3">报修/维修记录</el-menu-item>
          <el-menu-item index="3-4">升级记录</el-menu-item>
          <el-menu-item index="3-5">告警记录</el-menu-item>
        </el-submenu>
        <el-menu-item style="float: right;margin-right: 30px;">警报点编号:&nbsp;{{alarmPointId}}</el-menu-item>
      </el-menu>
    </div>
</template>

<script>
  import { ActionContext as store } from 'vuex'

  export default {
    name: 'AlarmViewNav',
    data(){
      return {
        activeIndex:'/alarmViewHome',
      }
    },
    computed:{
      alarmPointId () {
        return this.$store.state.alarmPointId;
      },
      activeRouter () {
        return this.$route.path;
      }
    }
  }
</script>

<style scoped>

</style>
